import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TCartItem } from '../../typings';
import { analyticsAddToBag } from '../../utils/googleAnalitics';
import * as basketActions from './basket.actions';

export interface IEntityBasket<T> {
  items: Array<T>;
  lastAddedItems: TCartItem[];
}

const initialState: IEntityBasket<TCartItem> = {
  items: JSON.parse(localStorage.getItem('basket') || '[]') || [],
  lastAddedItems: [],
};

const basketSlice = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    addToBasket: (state, action: PayloadAction<TCartItem>) => {
      const index = state.items.findIndex(
        (item) => item.uid === action.payload.uid && item.bundleId === action.payload.bundleId,
      );

      if (index >= 0) {
        state.items[index].quantity += 1;
      } else {
        state.items = state.items.concat({ ...action.payload, quantity: 1 });
      }
      state.lastAddedItems = [...state.lastAddedItems, { ...action.payload, quantity: 1 }];
      localStorage.setItem('basket', JSON.stringify(state.items));
      analyticsAddToBag(action.payload);
    },
    lowerTheAmount: (state, action: PayloadAction<TCartItem>) => {
      const index = state.items.findIndex(
        (item) => item.uid === action.payload.uid && item.bundleId === action.payload.bundleId,
      );
      if (state.items[index].quantity > 1) {
        state.items[index].quantity -= 1;
      } else {
        state.items = state.items.filter((_, i) => i !== index);
      }
      localStorage.setItem('basket', JSON.stringify(state.items));
    },
    removeFromBasket: (state, action: PayloadAction<TCartItem>) => {
      const index = state.items.findIndex(
        (item) => item.uid === action.payload.uid && item.bundleId === action.payload.bundleId,
      );

      state.items = state.items.filter((_, i) => i !== index);
      localStorage.setItem('basket', JSON.stringify(state.items));
    },
    clearLastAddedItems: (state) => {
      state.lastAddedItems = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(basketActions.checkout.fulfilled, (state) => {
      state.items = [];
      state.lastAddedItems = [];
      localStorage.setItem('basket', JSON.stringify([]));
    });
  },
});

export const basketAction = {
  ...basketSlice.actions,
  ...basketActions,
};

export const basketReducer = basketSlice.reducer;
